import React from 'react'
import type { IconDefaultProps } from '../../../models/types'

const MicrophoneRefusedIcon = ({
  className,
  color
}: IconDefaultProps): JSX.Element => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className || 'rf-h-6 rf-w-6'}
      viewBox='0 0 28.99 42.159'
    >
      <g transform='translate(-527.589 -229.523)'>
        <path
          d='M556.489,258.506h0a7.9,7.9,0,0,0,7.9-7.9v-8.817l-.07-.07-2.065,2.063a2.079,2.079,0,0,1-2.936,0l-1.557-1.557a2.084,2.084,0,0,1,0-2.936l2.06-2.06-2.063-2.063a2.084,2.084,0,0,1,0-2.936l1.557-1.557a2.073,2.073,0,0,1,.541-.387,7.906,7.906,0,0,0-11.283,7.147V250.6A7.9,7.9,0,0,0,556.489,258.506Z'
          transform='translate(-14.411 0)'
          fill={color || '#FFF'}
        />
        <path
          d='M555.259,279.916h-1.322a1.318,1.318,0,0,0-1.318,1.318v3.952a10.551,10.551,0,0,1-10.564,10.539q-.515,0-1.028-.051a10.859,10.859,0,0,1-9.487-10.957v-3.483a1.318,1.318,0,0,0-1.318-1.318h-1.314a1.318,1.318,0,0,0-1.318,1.318v3.307A14.945,14.945,0,0,0,540.105,299.5v2.813h-4.621a1.318,1.318,0,0,0-1.318,1.318v1.318a1.318,1.318,0,0,0,1.318,1.318h13.173a1.318,1.318,0,0,0,1.318-1.318v-1.318a1.318,1.318,0,0,0-1.318-1.318h-4.593v-2.78a14.505,14.505,0,0,0,12.514-14.345v-3.954A1.318,1.318,0,0,0,555.259,279.916Z'
          transform='translate(0 -34.583)'
          fill={color || '#FFF'}
        />
        <path
          d='M592.216,245.5h0l-3.29-3.29,3.29-3.29a.34.34,0,0,0,0-.479l-1.554-1.554a.34.34,0,0,0-.479,0l-3.288,3.29-.374-.374-2.918-2.916a.34.34,0,0,0-.479,0l-1.555,1.554a.34.34,0,0,0,0,.479l3.29,3.29-3.29,3.29a.34.34,0,0,0,0,.479l1.554,1.554a.34.34,0,0,0,.479,0l3.292-3.29.07.07,3.22,3.22a.339.339,0,0,0,.479,0l1.554-1.554A.339.339,0,0,0,592.216,245.5Z'
          transform='translate(-36.977 -4.985)'
          fill={color || '#FFF'}
        />
      </g>
    </svg>
  )
}

export default MicrophoneRefusedIcon
